import * as THREE from "three";

export interface GameScene {
  enter(): void;
  update(deltaSeconds: number): void;
  render(): void;
  resize(width: number, height: number): void;
  dispose(): void;
}

export function disposeObject(object: THREE.Object3D): void {
  object.traverse((child) => {
    const mesh = child as THREE.Mesh;
    mesh.geometry?.dispose();
    const materials = Array.isArray(mesh.material) ? mesh.material : [mesh.material];
    for (const material of materials) material?.dispose();
  });
}
